import { Injectable } from '@angular/core';

import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { isNumber, isString } from 'util';

import * as SearchMaskActions from '../actions/searchmask';
import * as DbActions from '../../services/db/state-management/actions/db';

import { SearchMask } from '../../../xena/core/shared/models/searchmask.model';
import { DocumentWithId, DocumentWithRev } from '../../services/db/models/document-with-type';
import { PaxloungeService } from '../../../xena/core/shared/services/paxlounge.service';


@Injectable()
export class SearchMaskEffects {
	@Effect() saveSearchMask$ = this._actions$
		.ofType<SearchMaskActions.SaveSearchMask>(SearchMaskActions.SAVE_SEARCH_MASK)
		.map(action => action.payload)
		.switchMap(searchMask => Observable.of(new  DbActions.Insert(searchMask)))
		.catch(() => Observable.of(new SearchMaskActions.SaveSearchMaskError()));

	@Effect() updateSearchMask$ = this._actions$
		.ofType<SearchMaskActions.UpdateSearchMask>(SearchMaskActions.UPDATE_SEARCH_MASK)
		.map(action => action.payload)
		.switchMap(searchMask => Observable.of(new  DbActions.Update(<SearchMask & DocumentWithId & DocumentWithRev>searchMask)))
		.catch(() => Observable.of(new SearchMaskActions.UpdateSearchMaskError()));

	@Effect() deleteSearchMask$ = this._actions$
		.ofType<SearchMaskActions.DeleteSearchMask>(SearchMaskActions.DELETE_SEARCH_MASK)
		.map(action => action.payload)
		.switchMap(searchMask => Observable.of(new  DbActions.Remove(<SearchMask & DocumentWithId & DocumentWithRev>searchMask)))
		.catch(() => Observable.of(new SearchMaskActions.DeleteSearchMaskError()));

	@Effect({dispatch: false}) loadSearchMaskSuccess$ = this._actions$
		.ofType<SearchMaskActions.LoadSearchMaskSuccess>(SearchMaskActions.LOAD_SEARCH_MASK_SUCCESS)
		.map(action => action.payload)
		.do(masks => {
			const tripId = localStorage.getItem('xenatransfer');

			if ((isString(tripId) && tripId.length > 0) || isNumber(tripId)) {
				this._paxloungeService.fillSearchMaskFromPaxLounge(Number(localStorage.getItem('xenatransfer')), masks);
				localStorage.removeItem('xenatransfer');
			}
		});

	public constructor(
		private _actions$: Actions,
		private _paxloungeService: PaxloungeService,
	) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/state-management/effects/searchmask.ts